import { ValueDisplayValue } from "./ValueDisplayValue";

export class ValueDisplayValueUtil {
    public static getDistinctValues(vdvs: ValueDisplayValue[]): string[] {
        return this.getDistinct(vdvs, (vdv) => vdv.value);
    }

    public static getDistinctDisplayValues(vdvs: ValueDisplayValue[]): string[] {
        return this.getDistinct(vdvs, (vdv) => vdv.displayValue);
    }

    public static getDistinct(vdvs: ValueDisplayValue[], fn: (vdv: ValueDisplayValue) => any): any[] {
        if (vdvs == null) {
            return [];
        }
        const distinctValues = new Set<string>();
        vdvs.forEach(vdv => {
            const value = fn(vdv);
            if (value != null) {
                distinctValues.add(vdv.value);
            }
        });
        return Array.from(distinctValues);
    }
}
